<template>
  <v-card pa-0>
    <v-card-title style="color:#000; background: #9FA8DA">
      <h3>Guidelines</h3>
    </v-card-title>
    <v-card-text>
      <p style="text-align: justify" class="headline"></p>
      <span style="color:#000" v-html="guidelines"></span>
    </v-card-text>
  </v-card>
</template>

<script>

  export default {
    name: "GuidelinesReader",
    props: {
      guidelines: String,
    },
    data() {
      return {}

    },
  };
</script>

<style lang="scss" scoped>
.ql-container {
  font-size: 16px;
}
.v-dialog{
  width: 40%;
}
.ql-toolbar .ql-stroke {
  fill: none;
  stroke: #fff;
}

.ql-toolbar .ql-fill {
  fill: #fff;
  stroke: none;
}

.ql-toolbar .ql-picker {
  color: #fff;
}
</style>

